import {
  CancelResDocument,
  CancelResMutationResult,
  CancelResMutationVariables,
} from "@graphql/api";

export default async function cancelRes(resId: number): Promise<boolean> {
  const client = global.window.apolloClient;
  const mutVars: CancelResMutationVariables = { resId };
  const result: CancelResMutationResult = await client.mutate({
    mutation: CancelResDocument,
    variables: mutVars,
  });

  return result.data.cancelRes.success;
}
